import { Chakra } from "@airhelp/react-ui-components";

import config from "config/config";

import { useTranslations } from "contexts/LocalizationContext/hooks";
import { useModal } from "contexts/ModalContext";

import { trackEvents } from "utils/trackingUtils";

import SectionHeader from "modules/common/components/SectionHeader";
import { ReviewCard } from "modules/common/components/Trustpilot";
import Grid from "modules/common/components/Grid";
import Modal from "modules/help-a-friend/components/Modal";

import { SHARE_NOW_CUSTOMERS_SAY_GTM, SHARE_NOW_CUSTOMERS_SAY_MP } from "modules/help-a-friend/trackingConsts";

const { Box, Button, Stack, Text, Image } = Chakra;

const RealTimeAdvice = () => {
  const translations = useTranslations();
  const { openModal } = useModal();

  const clickHandler = () => {
    openModal(<Modal />, "md");
    trackEvents({
      gtmEvent: SHARE_NOW_CUSTOMERS_SAY_GTM,
      mixpanelEvent: SHARE_NOW_CUSTOMERS_SAY_MP,
    });
  };

  const review = {
    consumer: {
      displayName: translations("what_customers_say_review_author"),
      displayLocation: translations("what_customers_say_review_location"),
    },
    text: translations("what_customers_say_review"),
  };

  return (
    <Grid mb={{ base: 16, lg: 28 }}>
      <Stack
        gridColumn={{ base: "initial", md: "1 / span 6", lg: "1 / span 5" }}
        backgroundColor={{ base: "white", lg: "initial" }}
        spacing={8}
        py={8}
      >
        <SectionHeader
          data-testid="customers-header"
          header={translations("what_customers_say_we_helped")}
          preheader={translations("what_customers_say")}
        />
        <Text fontSize="lg">{translations("what_customers_say_support")}</Text>
        <Box>
          <Button
            data-testid="customers-share-now"
            px={10}
            width={{ base: "100%", md: "initial" }}
            onClick={clickHandler}
            title={translations("button_share_now")}
          >
            {translations("button_share_now")}
          </Button>
        </Box>
      </Stack>
      <Box gridColumn={{ base: "initial", md: "8 / span 6" }} pos="relative">
        <Image
          display={{ base: "none", lg: "block" }}
          src={`${config.staticUrl}/i/referral-lp/customers-say.jpg`}
          pos="absolute"
          h="full"
          alt={translations("what_customers_say_review_image_alt")}
          objectFit="contain"
          loading="lazy"
        />
        <ReviewCard
          pos={{ lg: "absolute" }}
          left="-4rem"
          top="50%"
          transform={{ lg: "translateY(-50%)" }}
          review={review}
          width={{ md: "311px" }}
          data-testid="customers-img-review"
          border="none"
          boxShadow="alt"
          height="340px"
        />
      </Box>
    </Grid>
  );
};

export default RealTimeAdvice;
